
// const service_run = window.gtaAiConfig.service_run;
// const service_run_gl = window.gtaAiConfig.service_run_gl;

 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let service_run=getEnv(tag).service_run
 let service_interpreter=getEnv(tag).service_interpreter
 let service_run_gl=getEnv(tag).service_run_gl


export default {
  /**
   * ai-T编辑器运行python代码接口
   */
  serviceRun: `${service_run}/runcode/`,
  /**
   * 果力机器人运行接口
   */
  serviceRunGl: `${service_run_gl}/gl/run`,
  /**
   * 果力机器人停止接口
   */
  terminateGl: `${service_run_gl}/gl/terminate`,
  /**
   * python转javascript
   */
   pjRun: `${service_interpreter}/pj/run`,
 
}
